import { lazy } from "react";

const Dashboard = lazy(() => import("../Components/Dashboard/Default"));
const Users = lazy(() => import("../Components/Application/Admin/Users/Users"));
const Department = lazy(
  () => import("../Components/Application/Admin/Department/Department"),
);
const Broadcast = lazy(
  () => import("../Components/Application/Communication/Broadcast/Broadcast"),
);
const BroadcastDetails = lazy(
  () =>
    import("../Components/Application/Communication/Broadcast/BroadcastDetails"),
);
const Security = lazy(
  () => import("../Components/Application/Security/Security"),
);
const MediaRepository = lazy(
  () => import("../Components/Application/Project/Project"),
);
const SystemSetting = lazy(
  () => import("../Components/Application/SystemSetting/SystemSetting"),
);
const HealthOperation = lazy(
  () => import("../Components/Application/HealthOperation/HealthOperation"),
);
const SupportCenter = lazy(
  () => import("../Components/Application/SupportCenter/SupportCenter"),
);
const MyProfile = lazy(
  () => import("../Components/Application/Myprofile/MyProfile"),
);
const Mapping = lazy(
  () => import("../Components/Application/Admin/Whatsapp/Mapping/Mapping"),
);
const Routing = lazy(
  () => import("../Components/Application/Admin/Whatsapp/Routing/Routing"),
);
const Auditlog = lazy(() => import("../Components/AuditLogPage/Auditlog"));
const Report = lazy(
  () => import("../Components/Application/Project/Newproject"),
);
const DocumentSecurity = lazy(
  () =>
    import("../Components/Application/Admin/DocumentSecurity/DocumentSecurity"),
);
const TeamsGroups = lazy(
  () => import("../Components/Application/Admin/TeamsGroups/TeamsGroups"),
);
const Meetings = lazy(
  () => import("../Components/Application/Admin/Meetings/Meetings"),
);
const MeetingDetails = lazy(
  () => import("../Components/Application/Admin/Meetings/MeetingDetails"),
);

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/dashboard/:layout`,
    Component: Dashboard,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/:layout`,
    Component: Users,
  },
  {
    path: `${process.env.PUBLIC_URL}/departments/:layout`,
    Component: Department,
  },
  {
    path: `${process.env.PUBLIC_URL}/roles/:layout`,
    Component: Users,
  },
  {
    path: `${process.env.PUBLIC_URL}/broadcasts/:layout`,
    Component: Broadcast,
  },
  {
    path: `${process.env.PUBLIC_URL}/broadcasts/:id/:layout`,
    Component: BroadcastDetails,
  },
  {
    path: `${process.env.PUBLIC_URL}/whatsapp/mappings/:layout`,
    Component: Mapping,
  },
  {
    path: `${process.env.PUBLIC_URL}/whatsapp/logs/:layout`,
    Component: Routing,
  },
  {
    path: `${process.env.PUBLIC_URL}/audit/:layout`,
    Component: Auditlog,
  },
  {
    path: `${process.env.PUBLIC_URL}/media/:layout`,
    Component: MediaRepository,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/:layout`,
    Component: Report,
  },
  {
    path: `${process.env.PUBLIC_URL}/security/:layout`,
    Component: Security,
  },
  {
    path: `${process.env.PUBLIC_URL}/document-security/:layout`,
    Component: DocumentSecurity,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/:layout`,
    Component: SystemSetting,
  },
  {
    path: `${process.env.PUBLIC_URL}/health/:layout`,
    Component: HealthOperation,
  },
  {
    path: `${process.env.PUBLIC_URL}/support/:layout`,
    Component: SupportCenter,
  },
  {
    path: `${process.env.PUBLIC_URL}/profile/:layout`,
    Component: MyProfile,
  },
  {
    path: `${process.env.PUBLIC_URL}/teams-groups/:layout`,
    Component: TeamsGroups,
  },
  {
    path: `${process.env.PUBLIC_URL}/meetings/:layout`,
    Component: Meetings,
  },
  {
    path: `${process.env.PUBLIC_URL}/meetings/:id/:layout`,
    Component: MeetingDetails,
  },
];
